import { type Address } from '../routes/slice/gameSlice';
import { SUPPORTED_CHAIN_ID, supportedChainIds } from './chain';

const ADDRESS_MAP = {
  [SUPPORTED_CHAIN_ID.ARBI_SEPOLIA]: {
    factory: '0x0dDCA6882a142aBDccAa3308D0c3DBC71cc69385',
    USDT: '0xc0bd9ba30b3bdb8351efb19460996892092b100f',
  },
  [SUPPORTED_CHAIN_ID.SEPOLIA]: {
    factory: '0xc73391401473dd197F4e0886482cF7Fe44C8E7D0',
    USDT: '0xaca1bd2751121785794070fcc11658b5e506fb70',
  },
  [SUPPORTED_CHAIN_ID.ARBI]: {
    factory: '0x6Be116f560F45BCC46efD95F27df12C6D166bA93',
    USDT: '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9',
    USDC: '0xaf88d065e77c8cc2239327c5edb3a432268e5831',
  },
  [SUPPORTED_CHAIN_ID.BASE]: {
    factory: '0x32B6b04F463519B9F0b2439fb89c50DdcAe9D604',
    DAI: '0x50c5725949a6f0c72e6c4a641f24049a917db0cb',
    USDC: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
  },
  [SUPPORTED_CHAIN_ID.MANTLE]: {
    factory: '0x1f51c54Eb26d928A21F60644C7f9707f5D7fBaa6',
    USDT: '0x201eba5cc46d216ce6dc03f6a759e8e766e956ae',
    USDC: '0x09bc4e0d864854c6afb6eb9a9cdf58ac190d0df9',
  },
};

export const getAddress = (chainId: number, name: string) => {
  // @ts-ignore
  if (supportedChainIds.includes(chainId)) {
    // @ts-expect-error chain id is supported
    return ADDRESS_MAP[chainId][name];
  }
  return null;
};

export const getNameThroughAddress = (chainId: number, address: Address) => {
  // @ts-ignore
  if (supportedChainIds.includes(chainId)) {
    // @ts-expect-error chain id is supported
    const addresses = ADDRESS_MAP[chainId] ?? {};
    return Object.entries(addresses).find(([, addr]) => addr === address)?.[0];
  }
  return 'USDC';
};

export default ADDRESS_MAP;
